import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Rows2Icon, Users } from "lucide-react";
import HoursTooltip from "./tooltip/HoursTooltip";
import { useScheduleContext } from "../hooks/context/useScheduleContext";
import { useDateFilters } from "../../../../components/shared/filters/DateFilters/context/useDateFilters";

function Footer() {
    const { t } = useTranslation();
    const { mode } = useDateFilters();
    const { events, allResources } = useScheduleContext();
    const _events = useMemo(() => {
        return (mode === "month" ? [] : events)?.filter((event: any) => {
            return !["unavailable", "open-shifts"].includes(event?.type);
        })
    }, [events, mode]);

    // A user grouped under several rows is still one user
    const usersCount = useMemo(() => {
        return new Set(
            allResources
                ?.filter((resource: any) => resource.type !== "view-by")
                ?.map((resource: any) => resource.userId ?? resource.id)
        ).size;
    }, [allResources]);

    const title = useMemo(() => {
        if (mode === "week") return t("weekly-summary");
        if (mode === "day") return t("daily-summary");
        return t("summary")
    }, [mode, t]);

    return (
        <div className="scheduler-footer">
            <div className="footer-summary-title">
                {title}
            </div>

            <div className="footer-stats-container">
                <HoursTooltip />
                <div className="footer-stat-item">
                    <span className="tw-flex tw-items-center tw-text-neutral-500 tw-text-sm tw-gap-3">
                        <Rows2Icon size={16} /> <span>{t("shifts")}</span>
                    </span>
                    <span className="tw-font-bold">{_events?.length || 0}</span>
                </div>

                <div className="footer-stat-item">
                    <span className="tw-flex tw-items-center tw-text-neutral-500 tw-text-sm tw-gap-3">
                        <Users size={16} /> <span>{t("users")}</span>
                    </span>
                    <span className="tw-font-bold">
                        {usersCount}
                    </span>
                </div>
            </div>
        </div>
    );
}

export default Footer;
